import { FC, ReactElement } from "react"
import { useFormikContext } from "formik"

import { TenantConfigData } from "../../../types/api"
import { InputField } from "../../inputs/InputField"

export const FontConfigFields: FC = (): ReactElement => {
  const { handleChange, values } = useFormikContext<TenantConfigData>()
  return (
    <div className="mt-6">
      <h3>Dynamic Font</h3>
      <InputField
        name="fontConfig.fontFamily"
        value={values.fontConfig?.fontFamily ?? ""}
        onChange={handleChange}
        title="Font Family"
        placeholder="Inter"
      />
      <InputField
        name="fontConfig.fontUrl"
        value={values.fontConfig?.fontUrl ?? ""}
        onChange={handleChange}
        title="Font CSS URL"
        placeholder="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"
      />
    </div>
  )
}
